import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Mail = () => {
  const [toUser, setToUser] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState('');
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  // Get logged in user info
  const loggedInUser = JSON.parse(localStorage.getItem('user') || '{}');
  const fromUser = loggedInUser.username || loggedInUser.email || '';

  // Fetch users for dropdown, pass logged in user id to exclude self if needed
  useEffect(() => {
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/users?user_id=${loggedInUser.id}`)
      .then(res => res.json())
      .then(data => setUsers(data.users || []));
  }, [loggedInUser.id]);

  const handleSend = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus('');
    try {
  const res = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/send-mail`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          from: fromUser,
          to: toUser,
          subject,
          message,
        }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setStatus('Message sent successfully!');
        setToUser('');
        setSubject('');
        setMessage('');
      } else {
        setStatus(data.message || 'Failed to send message.');
      }
    } catch {
      setStatus('Failed to send message.');
    }
    setSending(false);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Send Mail</h2>
      <form onSubmit={handleSend} style={styles.form}>
        <label style={styles.label}>To User:</label>
        <select
          value={toUser}
          onChange={e => setToUser(e.target.value)}
          style={styles.input}
          required
        >
          <option value="">Select a user</option>
          {users.map(user => (
            <option key={user.id} value={user.email || user.username}>
              {user.firstName} {user.lastName} ({user.email || user.username})
            </option>
          ))}
        </select>
        <label style={styles.label}>Subject:</label>
        <input
          type="text"
          value={subject}
          onChange={e => setSubject(e.target.value)}
          style={styles.input}
          required
        />
        <label style={styles.label}>Message:</label>
        <textarea
          value={message}
          onChange={e => setMessage(e.target.value)}
          style={styles.textarea}
          rows={6}
          required
        />
        <button
          type="submit"
          style={styles.button}
          disabled={sending}
        >
          {sending ? 'Sending...' : 'Send'}
        </button>
        {status && <div style={styles.status}>{status}</div>}
      </form>
      <button
        style={styles.backBtn}
        onClick={() => navigate('/inbox')}
      >
        ← Back to Inbox
      </button>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    marginBottom: '28px',
    color: '#4078c0',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  label: {
    fontWeight: 'bold',
    color: '#8d6e36',
    fontSize: '1.08rem',
    marginBottom: '6px',
  },
  input: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    marginBottom: '8px',
  },
  textarea: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    marginBottom: '8px',
    resize: 'vertical',
  },
  button: {
    background: '#388e3c',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    transition: 'background 0.2s',
    marginTop: '8px',
  },
  backBtn: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    textDecoration: 'none',
    marginTop: '24px',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  status: {
    textAlign: 'center',
    color: '#388e3c',
    fontWeight: 'bold',
    marginTop: '8px',
  },
};

export default Mail;